import { render, staticRenderFns } from "./DialInPersonModal.vue?vue&type=template&id=83df82a8"
import script from "./DialInPersonModal.vue?vue&type=script&lang=js"
export * from "./DialInPersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports